import * as _ from 'underscore';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'doctorName'
})
export class DoctorNamePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(user: any, userId: string = undefined): string {
    user = user === undefined || user === null ? {} : user;
    let doctorName;
    user.firstName = !_.isUndefined(user.firstName) ? user.firstName.trim() : user.firstName;
    user.lastName = !_.isUndefined(user.lastName) ? user.lastName.trim() : user.lastName;
    if (!_.isEmpty(user.firstName) && !_.isEmpty(user.lastName)) {
      doctorName = user.lastName + ', ' + user.firstName;
    } else if (!_.isEmpty(user.firstName)) {
      doctorName = user.firstName;
    } else if (!_.isEmpty(user.lastName)) {
      doctorName = user.lastName;
    }

    if (user.userName === userId) {
      if (doctorName) {
        doctorName = doctorName + ' (' + this.translate.instant('label.you') + ')';
      } else {
        doctorName = this.translate.instant('label.you');
      }
    }
    return doctorName;
  }
}
